import React, { useState } from 'react'
import { Modal } from '../../../component/Modal'
import { SimpleButton } from '../../../component/Form/Button/SimpleButton'
import { DuetButtons } from '../../../component/ActionButtons/DuetButtons'
// import cl from './index.module.scss';


type Props = {
    delete: () => void
    disabled?: boolean
}

export const ModalDelete: React.FunctionComponent<Props> = (props) => {
    const [modalVisible, setModalVisible] = useState(false)
    const del = () => {
        setModalVisible(true)
    }
    const cancel = () => {
        setModalVisible(false)
    }
    return (
        <>
            <SimpleButton type='danger' click={del} disabled={props.disabled}>Удалить</SimpleButton>
            <Modal isShow={modalVisible} changed={setModalVisible}>
                <h1 className='font-kurale text-title font-20'
                    style={{ fontWeight: 'normal' }}>Удалить приём пищи?</h1>
                <p>Действие не обратимо, если только не загрузить сразу с сервера, пока там не удалено.</p>
                <div style={{ paddingTop: 64 }}>
                    <DuetButtons
                        first={{
                            type: 'transparent',
                            action: cancel,
                            content: 'Отмена',
                        }}
                        second={{
                            type: 'danger',
                            action: props.delete,
                            content: 'Удалить',
                        }}
                    />
                </div>
            </Modal>
        </>
    )
}
